<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <input
                  type="file"
                  class="custom-file-input"
                  id="importProductHolding"
                  lang="es"
                  v-on:change="chooseFile($event)"
                />
                <label class="custom-file-label" for="importProductHolding">
                  {{ Flie }}
                </label>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <button
                type="button"
                class="btn btn-info"
                @click="DownLoadTemplate()"
              >
                <i class="la la-save"></i> DownLoad Template
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="PreviewTable"
                style="width: 100%;"
              ></table>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="reset" class="btn btn-danger" @click="resetFile">
          <i class="la la-close"></i> ล้างค่า
        </button>
        <button v-show="submitBtn" type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      Flie: "เลือกไฟล์",
      seen: false,
      submitBtn: false,
      productHoldingList: [],
    };
  },
  methods: {
    formSubmit: function(e) {
      let self = this;
      let router = this.$router;
      e.preventDefault();

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      // add array list
      let items = [];
      self.productHoldingList.forEach((element) => {
        items.push({
          ProductTypeId: element.productTypeId,
          HolderTime: element.time,
          AgentCode: element.agentCode,
          ShopTypeId: element.shopTypeId,
          ProductBrandId: element.productBrandId,
          Status: element.status,
        });
      });

      axios
        .put("/Api/ProductHolder/Import", {
          Obj: items,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    resetFile: function() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importProductHolding").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.submitBtn = false;
    },
    DownLoadTemplate() {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/ProductHolder/Template",
        responseType: "arraybuffer",
        data: {},
      })
        .then(function(response) {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    chooseFile: function(e) {
      let self = this;
      let router = this.$router;
      self.seen = true;
      self.submitBtn = false;
      self.Flie = e.target.files[0].name;

      //Check extention
      let extension = self.Flie.split(".").pop();
      var extall = "xls,xlsx";

      // if(extension.match("xls|xlsx")){
      //   console.log(extension);
      // }

      if (parseInt(extall.indexOf(extension)) < 0) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกไฟล์ .xls หรือ .xlsx เท่านั้น",
          "warning"
        );
        self.Flie = "";
        return false;
      }

      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      self.productHoldingList = [];
      let formData = new FormData();
      formData.append("file", e.target.files[0]);

      axios
        .post("/Api/ProductHolder/Preview", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          self.productHoldingList = response.data.data;
          self.submitBtn = response.data.isValid;
          if (response.data.data.length > 0) {
            if (response.data.isValid) self.submitBtn = true;
          }

          var $table = $("#PreviewTable");
          var head =
            "<thead>" +
            '<tr role="row">' +
            '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" style="width:5% ;">ลำดับ</th>' +
            '<th class="text-center" aria-label="รหัสประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >รหัสประเภทสินค้าถือครอง</th>' +
            '<th class="text-center" aria-label="ประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >ประเภทสินค้าถือครอง</th>' +
            '<th class="text-center" aria-label="รหัสตัวแทนจำหน่าย: activate to sort column ascending" style="width:10%;">รหัสตัวแทนจำหน่าย</th>' +
            '<th class="text-center" aria-label="ตัวแทนจำหน่าย: activate to sort column ascending" style="width:15%;">ตัวแทนจำหน่าย</th>' +
            '<th class="text-center" aria-label="รหัสประเภทร้านค้า: activate to sort column ascending" style="width:8% ;">รหัสประเภทร้านค้า</th>' +
            '<th class="text-center" aria-label="ประเภทร้านค้า: activate to sort column ascending" style="width:10% ;">ประเภทร้านค้า</th>' +
            '<th class="text-center" aria-label="รหัสแบรนด์สินค้า: activate to sort column ascending" style="width: 8%;">รหัสแบรนด์สินค้า</th>' +
            '<th class="text-center" aria-label="แบรนด์สินค้า: activate to sort column ascending" style="width: 10%;">แบรนด์สินค้า</th>' +
            '<th class="text-center" aria-label="ระยะเวลาการถือครอง(วัน): activate to sort column ascending" style="width:10% ;">ระยะเวลาการถือครอง(วัน)</th>' +
            '<th class="text-center" aria-label="สถานะ: activate to sort column ascending" style="width:10% ;">สถานะ</th>' +
            "</tr>" +
            "</thead>";
          $table.append(head);
          var data = response.data.data;
          var table_body = $("<tbody></tbody>");
          for (var i = 0; i < data.length; i++) {
            $(
              '<tr role="row" class="odd"><td class="text-center">' +
                (i + 1) +
                "</td>" +
                '<td class="text-center" ' +
                data[i].productTypeIdCSS +
                ">" +
                data[i].productTypeId +
                "</td>" +
                '<td class="text-center" ' +
                data[i].productTypeIdCSS +
                ">" +
                data[i].productTypeName +
                "</td>" +
                '<td class="text-center" ' +
                data[i].agentCodeCSS +
                ">" +
                data[i].agentCode +
                "</td>" +
                '<td class="text-center" ' +
                data[i].agentCodeCSS +
                ">" +
                data[i].agentName +
                "</td>" +
                '<td class="text-center" ' +
                data[i].shopTypeIdCSS +
                ">" +
                data[i].shopTypeId +
                "</td>" +
                '<td class="text-center" ' +
                data[i].shopTypeIdCSS +
                ">" +
                data[i].shopTypeName +
                "</td>" +
                '<td class="text-center" ' +
                data[i].productBrandIdCSS +
                ">" +
                data[i].productBrandId +
                "</td>" +
                '<td class="text-center" ' +
                data[i].productBrandIdCSS +
                ">" +
                data[i].productBrandName +
                "</td>" +
                '<td class="text-center" ' +
                data[i].timeCSS +
                ">" +
                data[i].time +
                "</td>" +
                '<td class="text-center" ' +
                data[i].statusCSS +
                ">" +
                data[i].status +
                "</td>" +
                "</tr>"
            ).appendTo(table_body);
            table_body.appendTo($table);
          }
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    // $("#importProductHolding").change(function(e) {
    //   self.seen = true;
    //   self.Flie = e.target.files[0].name;
    //   $("#PreviewTable thead").remove();
    //   $("#PreviewTable tbody").remove();
    //   self.productHoldingList = [];
    //   let formData = new FormData();
    //   formData.append("file", e.target.files[0]);
    //   axios
    //     .post("/Api/ProductHolder/Preview", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data"
    //       }
    //     })
    //     .then(response => {
    //       self.productHoldingList = response.data.data;
    //       self.submitBtn = response.data.isValid;
    //       self.submitBtn = response.data.data.length > 0 ? true : false;

    //       var $table = $("#PreviewTable");
    //       var head =
    //         "<thead>" +
    //         '<tr role="row">' +
    //         '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" style="width:5% ;">ลำดับ</th>' +
    //         '<th class="text-center" aria-label="รหัสประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >รหัสประเภทสินค้าถือครอง</th>' +
    //         '<th class="text-center" aria-label="รหัสตัวแทนจำหน่าย: activate to sort column ascending" style="width:15%;">รหัสตัวแทนจำหน่าย</th>' +
    //         '<th class="text-center" aria-label="รหัสประเภทร้านค้า: activate to sort column ascending" style="width:10% ;">รหัสประเภทร้านค้า</th>' +
    //         '<th class="text-center" aria-label="รหัสแบรนด์สินค้า: activate to sort column ascending" style="width: 10%;">รหัสแบรนด์สินค้า</th>' +
    //         '<th class="text-center" aria-label="ระยะเวลาการถือครอง(วัน): activate to sort column ascending" style="width:10% ;">ระยะเวลาการถือครอง(วัน)</th>' +
    //         '<th class="text-center" aria-label="สถานะ: activate to sort column ascending" style="width:10% ;">สถานะ</th>' +
    //         "</tr>" +
    //         "</thead>";
    //       $table.append(head);
    //       var data = response.data.data;
    //       var table_body = $("<tbody></tbody>");
    //       for (var i = 0; i < data.length; i++) {

    //         $(
    //           '<tr role="row" class="odd"><td class="text-center">' +
    //             (i + 1) +"</td>" +
    //             '<td class="text-center" '+data[i].productTypeIdCSS +'>' +
    //             data[i].productTypeId +
    //             '</td>' +
    //             '<td class="text-center" '+data[i].agentCodeCSS +'>' +
    //             data[i].agentCode +
    //             '</td>' +
    //             '<td class="text-center" '+data[i].shopTypeIdCSS +'>' +
    //             data[i].shopTypeId +
    //             '</td>' +
    //             '<td class="text-center" '+data[i].productBrandIdCSS +'>' +
    //             data[i].productBrandId +
    //             '</td>' +
    //             '<td class="text-center" '+data[i].timeCSS +'>' +
    //             data[i].time +
    //             '</td>'+
    //             '<td class="text-center" '+data[i].statusCSS +'>' +
    //             data[i].status +
    //             '</td>'+
    //             '</tr>'
    //         ).appendTo(table_body);
    //         table_body.appendTo($table);
    //       }
    //     });
    // });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {},
      messages: {},
    });
  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  cursor: pointer;
}
td.border_single {
  border: 1px solid #ff0000;
}
#PreviewTable td {
  border: 1px solid #ff0000;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Holding/HoldingImportModal.vue